import DaasTableRowCell from '@/components/table/DaasTableRowCell';
import { cn } from '@/lib/utils';
import { PeripheralFinanceModelTypes } from '@/services/api/contracts/financemodels';
import { FunctionComponent } from 'react';
import { FiEdit } from 'react-icons/fi';
import { getModelTypeString, getPeripheralModelTypeString } from '../bulk/helpers/utils';
import { FinanceModelsTableData } from './FinanceModelsTable';

interface Props {
  data: FinanceModelsTableData;
  onEdit: () => void;
}

const FinanceModelsRow: FunctionComponent<Props> = ({ data, onEdit }) => {
  const modelType = data.isPeripheral
    ? getPeripheralModelTypeString(data.type as unknown as PeripheralFinanceModelTypes)
    : getModelTypeString(data.type);

  return (
    <>
      <DaasTableRowCell>{data.name}</DaasTableRowCell>
      <DaasTableRowCell>{data.categoryName}</DaasTableRowCell>
      <DaasTableRowCell>{data.isPeripheral ? '-' : data.manufacturerName}</DaasTableRowCell>
      <DaasTableRowCell>{data.term > 0 ? `${data.term} year${data.term !== 1 ? 's' : ''}` : '-'}</DaasTableRowCell>
      <DaasTableRowCell>{modelType}</DaasTableRowCell>
      <DaasTableRowCell className="!p-0 flex [&>*:not(:last-child)]:border-r">
        {data.pcms.map(item => (
          <div
            key={`${data.id}-${item.region}-${item.value}`}
            className={cn(
              'h-full border-[#DDDDDD] flex flex-1 items-center px-3 py-2',
              item.value ? 'justify-between' : 'justify-center'
            )}
          >
            {item.value ? +item.value.toFixed(6) : '-'}
          </div>
        ))}
      </DaasTableRowCell>
      <DaasTableRowCell>
        <button onClick={onEdit}>
          <FiEdit />
        </button>
      </DaasTableRowCell>
    </>
  );
};

export default FinanceModelsRow;
